export const maxLengthValidation = (text: any, maxLength: any): boolean => {
  if (text?.length > maxLength) {
    return false;
  } else {
    return true;
  }
};

// username Validation
export const usernameValidation = (username: string): boolean => {
  const regex = /^[-_.@0-9A-Za-z]+$/;
  return regex.test(username);
};

export const urlValidation = (url: string): boolean => {
  // const regex = /^[a-z0-9]{10,20}$/;
  // 영문 소문자 및 숫자로 이루어진 문자열
  const regex = /^[a-z0-9]$/;
  // console.log("urlValidation", url, regex.test(url));
  // return regex.test(url);
  return regex.test(url);
};
export const usernameLengthValidation = (username: any): boolean => {
  //console.log(username.length)
  return username === "" || username.length < 3;
};

export const usernameSameAs = (
  newUserName: any,
  currentUserName: any
): boolean => {
  console.log(newUserName === currentUserName);
  return newUserName === currentUserName;
};

export const emailValidation = (email: string): boolean => {
  // /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  // if (maxLengthValidation(email)) {
  const regex =
    /^[0-9a-zA-Z+]([-_\\.+]?[0-9a-zA-Z+])*@[0-9a-zA-Z]([-_\\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,}$/i;
  // const regex =
  //   /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])+\\@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])+\.[a-zA-Z]{2,3}$/;
  return regex.test(email);
  // } else return false
};

// passwordValidation
export const passwordValidation = (password: any): boolean => {
  const regex =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,16}$/;
  return regex.test(password);
};

export const numberValidation = (number: any): boolean => {
  const regNum = /^[+-]?[0-9]*$/;
  return regNum.test(number);
};

// phoneValidation
export const phoneValidation = (number: any): boolean => {
  const regNum = /^[+-]?[0-9-]*$/;
  return regNum.test(number);
};

export const arrayLengthValidation = (array: any): boolean => {
  return array.length > 0;
};

// username Validation
export const urlNameValidation = (url: any): boolean => {
  const regex = /^[a-z]+[a-z0-9-]{1,19}$/;
  // console.log("urlNameValidation", url, regex.test(url));
  return regex.test(url);
};

export const arrayNameValidationByKey = (
  array: any,
  key: any,
  childKey: any
): boolean => {
  let passValidation = true;
  if (key === "children") {
    array.forEach((arr: any) => {
      if (arr.children) {
        arr.children.forEach((child: any) => {
          if (!child[childKey]) {
            return (passValidation = false);
          }
        });
      }
    });
  } else {
    array.forEach((arr: any) => {
      if (!arr[key]) {
        return (passValidation = false);
      }
    });
  }

  return passValidation;
};

// 음수 포함
export const validationForNegativeNumber = (validNumber: any): number => {
  if (validNumber > 32767) {
    validNumber = 32767;
  } else if (validNumber < -32768) {
    validNumber = -32768;
  }

  return validNumber;
};

// 양수 (0~65535)
export const validationForDualNumber = (validNumber: any): number => {
  if (+validNumber > 65535) {
    validNumber = 65535;
  } else if (+validNumber < 0) {
    validNumber = 0;
  }

  return validNumber;
};

// // ip 형식
export const ipRegx = (number: any): boolean => {
  const regNum =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  return regNum.test(number);
};

// ip 숫자
export const ipNumber = (number: any): boolean => {
  const regNum = /^[.]?[0-9.]*$/;
  return regNum.test(number);
};

/**
 * IP첫자리 * 16777216 + IP둘째자리 * 65536 + IP셋째자리 * 256 + IP넷째자리 이값이 앞보다 뒤가 커야 합니다.
 */
export const calcIpAddress = (array: any): number => {
  return array.reduce((accum: any, currVal: any, index: any, array: any) => {
    let calcValue = 0;
    const setNumber = Number(currVal);
    switch (index) {
      case 1:
        calcValue = setNumber * 16777216;
        break;
      case 2:
        calcValue = setNumber * 65536;
        break;
      case 3:
        calcValue = setNumber * 256;
        break;
      case 4:
        calcValue = setNumber * 1;
        break;
    }

    return Number(accum + calcValue);
  });
};
